import { r as registerInstance, c as createEvent, f as forceUpdate, h, g as getElement, H as Host } from './index-5faac9d7.js';
import { c as classnames } from './index-43880fda.js';
import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { i as isMobile } from './utils-6c8f178b.js';
import { f as virtualPagesNestedLocations } from './analytics-b3108572.js';
import { d as EQdsButtonSize, c as EQdsButtonImportance, aa as pesIconSizes, ak as pesIconMirrorDirection } from './currency-49e0d692.js';
import './index-39f51a91.js';
import { s as send, x as productSelectorVirtualPageEvent } from './analytics-74fe4f64.js';
import { g as getData } from './http-65330442.js';
import './_commonjsHelpers-7db8bc26.js';
import './_nodeUtil-549406aa.js';
import './lodash-7f024380.js';
import './_Stack-cf94d4e7.js';
import './number-fcf5283d.js';
import './navigation-83d2f79a.js';

const hmcCardCss = ":host{display:block}.hmc-card{position:relative;display:flex;font-size:14px;line-height:20px;color:#626469}.hmc-card .highlight-naming{font-weight:400}.hmc-card .highlight-naming .accent{font-weight:700}@media screen and (max-width: 979px){.hmc-card{padding:16px}}@media screen and (min-width: 980px){.hmc-card{padding:24px 24px 56px}}.hmc-card--best-match{border:1px solid #3dcd58}@media screen and (min-width: 980px){.hmc-card--best-match{padding:24px}}.hmc-card__img-link-wrapper{cursor:pointer;display:block}@media screen and (max-width: 979px){.hmc-card__img-link-wrapper{height:60px;width:60px}:host(:not([dir=\"rtl\"])) .hmc-card__img-link-wrapper{margin-right:16px}:host([dir=\"rtl\"]) .hmc-card__img-link-wrapper{margin-left:16px}}@media screen and (min-width: 980px){.hmc-card__img-link-wrapper{height:130px}:host(:not([dir=\"rtl\"])) .hmc-card__img-link-wrapper{margin-right:24px}:host([dir=\"rtl\"]) .hmc-card__img-link-wrapper{margin-left:24px}}.hmc-card__img-link-wrapper:hover{cursor:pointer}@media screen and (max-width: 979px){.hmc-card__img{max-height:60px;min-width:60px;max-width:60px}}@media screen and (min-width: 980px){.hmc-card__img{min-width:130px;max-width:130px;max-height:130px}}.hmc-card__text-content{display:flex;flex-direction:column;width:100%}@media screen and (max-width: 979px){.hmc-card__text-content{max-width:calc(100% - 76px)}}@media screen and (min-width: 980px){.hmc-card__text-content{max-width:calc(100% - 154px)}}.hmc-card__text-content-link-wrapper{cursor:pointer;display:flex;flex-direction:column;color:#626469;text-decoration:none}.hmc-card__badge{display:none;margin-bottom:12px}.hmc-card--best-match .hmc-card__badge{display:flex}.hmc-card__title{font-size:16px;line-height:24px;color:#333333;margin:0 0 8px;padding:0;height:100%}.hmc-card__title .highlight-naming{font-weight:400}.hmc-card__title .highlight-naming .accent{font-weight:700}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .hmc-card__title{padding-right:50px}:host([dir=\"rtl\"]) .hmc-card__title{padding-left:50px}}.hmc-card__text-content-link-wrapper:hover .hmc-card__title,.hmc-card__img-link-wrapper:hover+.hmc-card__text-content .hmc-card__title{text-decoration:underline}.hmc-card__description{overflow:hidden}.hmc-card__master-range-info{margin-top:8px}.hmc-card__text-content-link-wrapper:hover .hmc-card__view-products,.hmc-card__img-link-wrapper:hover+.hmc-card__text-content .hmc-card__view-products{text-decoration:underline}@media screen and (max-width: 979px){.hmc-card__information{display:none}}@media screen and (min-width: 980px){.hmc-card__information{position:absolute;top:24px;width:18px;height:18px;cursor:pointer}:host(:not([dir=\"rtl\"])) .hmc-card__information{right:24px}:host([dir=\"rtl\"]) .hmc-card__information{left:24px}}.hmc-card__tooltip-text{font-size:14px;width:auto;overflow:hidden}.hmc-card__tooltip-title{font-size:14px;line-height:20px;margin-bottom:10px;text-transform:capitalize;font-weight:bold}";

const DESCRIPTION_MAX_HEIGHT = '60px';
const TOOLTIP_MAX_HEIGHT = '298px';
const HmcCard = class {
  handleChangeRangeTooltipInfo() {
    this.tooltipContent = this.getTooltipContent();
  }
  getTooltipContent() {
    const { rangeId } = this.range;
    if (this.rangeTooltipInfo && rangeId in this.rangeTooltipInfo) {
      const { presentation1, presentation2 } = this.rangeTooltipInfo[rangeId];
      return [presentation1, presentation2].filter(Boolean).join(' ');
    }
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didCloseDialog = createEvent(this, "didCloseDialog", 7);
    this.handleTooltipActivate = () => {
      var _a;
      (_a = this.tooltipContentRef) === null || _a === void 0 ? void 0 : _a.triggerUpdate();
    };
    this.getRangeDescription = () => {
      const { description, longDescription } = this.range;
      return [description, longDescription].filter(Boolean).join(' ');
    };
    this.handleLinkMouseOver = () => {
      this.linkHovered = true;
    };
    this.handleLinkMouseOut = () => {
      this.linkHovered = false;
    };
    this.handleLinkClick = () => {
      this.didCloseDialog.emit();
    };
    this.range = undefined;
    this.isBestMatch = undefined;
    this.labels = undefined;
    this.rangeTooltipInfo = {};
    this.page = 'all-products';
    this.selectorConfig = {};
    this.isPBS = false;
    this.linkHovered = false;
    this.tooltipContent = this.getTooltipContent();
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    forceUpdate(this.host);
  }
  render() {
    var _a, _b, _c, _d, _e;
    return (h("div", { class: classnames('hmc-card', {
        'hmc-card--best-match': this.isBestMatch,
      }) }, h("pes-router-link", { page: this.page, pageId: this.range.rangeId, url: !this.isPBS ? this.range.selfRef : null, target: "_self", class: "hmc-card__img-link-wrapper" }, h("a", { href: "#", onMouseOver: this.handleLinkMouseOver, onMouseOut: this.handleLinkMouseOut }, h("img", { class: "hmc-card__img", src: this.range.imageUrl, alt: "" }))), h("div", { class: "hmc-card__text-content" }, h("pes-router-link", { page: this.page, pageId: this.range.rangeId, url: !this.isPBS ? this.range.selfRef : null, target: "_self" }, h("a", { class: "hmc-card__text-content-link-wrapper", href: "#", onClick: this.handleLinkClick, onMouseOver: this.handleLinkMouseOver, onMouseOut: this.handleLinkMouseOut }, h("pes-badge", { class: "hmc-card__badge", label: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.bestMatchLabel }), h("h3", { class: "hmc-card__title", innerHTML: this.range.name }), h("pes-ellipsis", { class: "hmc-card__description", maxHeight: DESCRIPTION_MAX_HEIGHT, content: this.getRangeDescription() }), this.range.masterRangeInfo && (h("div", { class: "hmc-card__master-range-info", innerHTML: this.range.masterRangeInfo })), h("pes-hmc-link", { class: "hmc-card__view-products", active: this.linkHovered }, this.range.hasProducts
      ? (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcViewProducts
      : (_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcViewDetails))), h("pes-hmc-product-selector", { functionalIds: this.range.productConfiguratorUrl, selectorConfig: this.selectorConfig, legacyConfiguratorUrl: this.range.legacyConfiguratorUrl, useProductSelectorLabel: (_d = this.labels) === null || _d === void 0 ? void 0 : _d.useProductSelector, selectorHeaderLabel: this.range.name })), this.tooltipContent && (h("pdp-icon-tooltip", { class: "hmc-card__information", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top", onDidOpen: this.handleTooltipActivate }, h("div", { class: "hmc-card__tooltip" }, h("div", { class: "hmc-card__tooltip-title" }, (_e = this.labels) === null || _e === void 0 ? void 0 : _e.featuresLabel), h("pes-ellipsis", { ref: (el) => (this.tooltipContentRef = el), class: "hmc-card__tooltip-text", maxHeight: TOOLTIP_MAX_HEIGHT, content: this.tooltipContent }))))));
  }
  get host() { return getElement(this); }
  static get watchers() { return {
    "rangeTooltipInfo": ["handleChangeRangeTooltipInfo"]
  }; }
};
HmcCard.style = hmcCardCss;

const hmcLinkCss = "@media screen and (min-width: 980px){:host{padding-top:4px}}";

const HmcLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.active = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("qds-standalone-link", { size: "standard", importance: "standard" }, h("slot", null))));
  }
  get el() { return getElement(this); }
};
HmcLink.style = hmcLinkCss;

const hmcModalCss = ".hmc-modal__content{display:block}@media screen and (max-width: 979px){.hmc-modal__content{margin:0 -8px;max-width:100vw}}@media screen and (min-width: 980px){.hmc-modal__content{height:80vh;padding:0 20px;max-width:1040px}}";

const HmcModal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.resizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.data = undefined;
    this.rangeTooltipInfo = undefined;
    this.selectorConfig = undefined;
    this.isOpened = false;
    this.isPBS = false;
    this.isMobile = isMobile();
  }
  connectedCallback() {
    window.addEventListener('resize', this.resizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  render() {
    var _a, _b;
    return (h("se-dialog", { open: this.isOpened, size: this.isMobile ? 'fill' : 'xlarge', pageScroll: false }, h("se-dialog-header", { closeIcon: true }, (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.helpMeChooseLabel), h("se-dialog-content", { isLastChild: false }, h("div", { class: "hmc-modal__content" }, h("se-loading", { loading: isEmpty_1(this.data) && this.isOpened }), !isEmpty_1(this.data) && (h("pes-widget-body", { data: this.data, isPBS: this.isPBS, rangeTooltipInfo: this.rangeTooltipInfo, selectorConfig: this.selectorConfig, isMobile: this.isMobile }))))));
  }
};
HmcModal.style = hmcModalCss;

const hmcProductSelectorCss = ".pes-product-selector__link{cursor:pointer}@media screen and (min-width: 980px){.pes-product-selector__link{margin-top:12px}}";

const ProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didOpenProductSelector = createEvent(this, "didOpenProductSelector", 7);
    this.handleOpenProductSelector = (selector, config) => (_) => {
      this.didOpenProductSelector.emit();
      if (config.type === 'sc') {
        const host = document.createElement('pdp-sc-selector-modal');
        const frame = document.createElement('div');
        frame.id = 'widgetFrame';
        host.headerLabel = config.scLabel || this.selectorHeaderLabel || 'Select your product';
        host.appendChild(frame);
        host.open = true;
        host.addEventListener('didClose', () => {
          document.body.removeChild(host);
        });
        document.body.appendChild(host);
      }
      selector.open(config);
      send(productSelectorVirtualPageEvent, {
        location: virtualPagesNestedLocations.HELP_ME_CHOOSE,
      });
    };
    this.openConfigurator = () => {
      window.open(this.legacyConfiguratorUrl, '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=1070, height=700');
    };
    this.renderProductSelector = () => {
      const config = Object.assign(Object.assign({}, this.selectorConfig), { scFunctionalIds: this.functionalIds });
      return (h("pes-product-selector", { config: config, renderFunction: (selector) => (h("qds-standalone-link", { size: "standard", importance: "standard", class: "pes-product-selector__link", onClick: this.handleOpenProductSelector(selector, config) }, this.useProductSelectorLabel)) }));
    };
    this.functionalIds = undefined;
    this.selectorConfig = undefined;
    this.legacyConfiguratorUrl = undefined;
    this.useProductSelectorLabel = undefined;
    this.selectorHeaderLabel = undefined;
  }
  render() {
    if ((!this.functionalIds || isEmpty_1(this.selectorConfig)) && !this.legacyConfiguratorUrl) {
      return;
    }
    if (this.functionalIds) {
      return this.renderProductSelector();
    }
    return (h("qds-standalone-link", { size: "standard", importance: "standard", class: "pes-product-selector__link", onClick: this.openConfigurator }, this.useProductSelectorLabel));
  }
};
ProductSelector.style = hmcProductSelectorCss;

const HmcWidget = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.closeModal = () => {
      this.data = null;
      this.rangeTooltipInfo = null;
      this.isOpened = false;
    };
    this.fetchQuestionnaire = (id) => {
      if (!id) {
        return;
      }
      const rest = this.questionnaireUrl.replace(':id', id);
      getData(false, rest).then((res) => {
        if (!isEmpty_1(res)) {
          this.data = res;
        }
      });
    };
    this.fetchSelectorConfig = () => {
      getData(false, this.selectorConfigUrl).then((res) => {
        if (!isEmpty_1(res)) {
          this.selectorConfig = res;
        }
      });
    };
    this.createRangeTooltipInfoMap = (presentations) => presentations.reduce((obj, range) => {
      if (!obj[range.rangeId]) {
        return Object.assign(Object.assign({}, obj), { [range.rangeId]: range });
      }
      return Object.assign({}, obj);
    }, {});
    this.fetchRangeTooltipInfo = (rangeIds) => {
      if (!rangeIds) {
        return;
      }
      if (!isEmpty_1(this.rangeTooltipInfo)
        && rangeIds.every((id) => Object.keys(this.rangeTooltipInfo).includes(id))) {
        return this.rangeTooltipInfo;
      }
      const rest = this.rangeTooltipUrl.replace(':ids', rangeIds.join());
      getData(false, rest).then((res) => {
        if (!isEmpty_1(res) && !isEmpty_1(res.presentations)) {
          this.rangeTooltipInfo = this.createRangeTooltipInfoMap(res.presentations);
        }
      });
    };
    this.categoryId = undefined;
    this.questionnaireUrl = undefined;
    this.rangeTooltipUrl = undefined;
    this.selectorConfigUrl = undefined;
    this.isPBS = false;
    this.data = undefined;
    this.rangeTooltipInfo = undefined;
    this.selectorConfig = undefined;
    this.isOpened = false;
  }
  handleRangesDisplay(e) {
    const rangesIds = e.detail;
    this.fetchRangeTooltipInfo(rangesIds);
  }
  handleCloseDialog() {
    this.closeModal();
  }
  handleOpenProductSelector() {
    this.closeModal();
  }
  componentWillLoad() {
    this.fetchQuestionnaire(this.categoryId);
    this.fetchSelectorConfig();
    this.isOpened = true;
  }
  render() {
    return (h("pes-hmc-modal", { data: this.data, isPBS: this.isPBS, isOpened: this.isOpened, rangeTooltipInfo: this.rangeTooltipInfo, selectorConfig: this.selectorConfig }));
  }
};

const widgetAnswersCss = "@media screen and (max-width: 979px){:host{display:block;width:100%;padding-bottom:96px}}";

const WidgetAnswers = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.answers = undefined;
    this.selectedAnswer = undefined;
  }
  render() {
    return h("pes-chips-list", { data: this.answers, selected: this.selectedAnswer });
  }
};
WidgetAnswers.style = widgetAnswersCss;

const WidgetBackButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didBackButtonClick = createEvent(this, "didBackButtonClick", 7);
    this.handleButtonClick = () => {
      this.didBackButtonClick.emit();
    };
    this.backLabel = undefined;
  }
  render() {
    return (h("qds-standalone-link", { size: EQdsButtonSize.SMALL, importance: EQdsButtonImportance.STANDARD, onClick: this.handleButtonClick, iconName: "chevron-left" }, this.backLabel));
  }
};

const getQuestionnaireItemByPath = (childItems, path, index = 0) => {
  var _a;
  const lastIndex = path.length - 1;
  let questionnaireItem = childItems.find((item) => item.answer === path[index]);
  if (!!((_a = questionnaireItem === null || questionnaireItem === void 0 ? void 0 : questionnaireItem.childItems) === null || _a === void 0 ? void 0 : _a.length) && lastIndex !== index) {
    questionnaireItem = getQuestionnaireItemByPath(questionnaireItem.childItems, path, index + 1);
  }
  return questionnaireItem;
};
const generatePath = (selectedItem, selectedChild, isLastSelected) => {
  var _a;
  if (!((_a = selectedItem.path) === null || _a === void 0 ? void 0 : _a.length)) {
    return [selectedChild.answer];
  }
  const { path } = selectedItem;
  const pathToParent = path.slice(0, path.length - 1);
  return isLastSelected && (pathToParent === null || pathToParent === void 0 ? void 0 : pathToParent.length) !== 0
    ? [...pathToParent, selectedChild.answer]
    : [...path, selectedChild.answer];
};
function isSelectedItem(item) {
  return 'answer' in item && 'question' in item && 'childItems' in item && 'rangeIds' in item;
}
const createSelectedItem = (item, path) => ({
  answer: item.answer,
  childItems: item.childItems,
  question: item.question,
  rangeIds: isSelectedItem(item) ? item.rangeIds : [],
  path,
});

const widgetBodyCss = ".widget-body{display:flex;flex-direction:column;position:relative;height:100%}.widget-body__question{display:flex;justify-content:center;align-items:center;flex-direction:column;padding-bottom:16px;width:100%}@media screen and (min-width: 980px){.widget-body__question{border-bottom:1px solid #e7e6e6}}.widget-body__question--first{border:none}@media screen and (min-width: 980px){.widget-body__question--first{height:100%}}.widget-body__back-button{visibility:hidden}.widget-body__back-button--visible{visibility:visible}";

const WidgetBody = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didDisplayRanges = createEvent(this, "didDisplayRanges", 7);
    this.data = undefined;
    this.rangeTooltipInfo = undefined;
    this.selectorConfig = undefined;
    this.isMobile = undefined;
    this.isPBS = false;
    this.currentSelected = undefined;
    this.previousSelected = undefined;
    this.isLastSelected = false;
    this.question = undefined;
    this.answers = undefined;
    this.ranges = undefined;
    this.breadcrumbs = [];
  }
  onItemSelect(event) {
    var _a, _b, _c, _d;
    const value = event.detail;
    const selectedChild = this.isLastSelected
      ? (_b = (_a = this.previousSelected) === null || _a === void 0 ? void 0 : _a.childItems) === null || _b === void 0 ? void 0 : _b.find((item) => item.answer === value)
      : (_d = (_c = this.currentSelected) === null || _c === void 0 ? void 0 : _c.childItems) === null || _d === void 0 ? void 0 : _d.find((item) => item.answer === value);
    if (selectedChild) {
      const path = generatePath(this.currentSelected, selectedChild, this.isLastSelected);
      this.currentSelected = createSelectedItem(selectedChild, path);
    }
  }
  onBreadcrumbClicked(e) {
    const { path } = e.detail;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.currentSelected = this.getParentItemByPath(path);
    }
  }
  onBackButtonClick() {
    const { path } = this.currentSelected;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.currentSelected = this.getParentItemByPath(path);
    }
  }
  onSelectedChange() {
    this.setIsLastSelected();
    this.getPreviousSelected();
    this.getCurrentQuestion();
    this.getCurrentAnswers();
    this.filterRanges();
    this.createBreadcrumbs();
  }
  onRangesDisplay() {
    var _a;
    if ((_a = this.ranges) === null || _a === void 0 ? void 0 : _a.length) {
      const rangesIds = this.ranges.map((range) => range.rangeId);
      this.didDisplayRanges.emit(rangesIds);
    }
  }
  getParentItemByPath(path) {
    const pathToParent = path.slice(0, path.length - 1);
    const questionnaireItem = getQuestionnaireItemByPath(this.data.questionnaire.questionnaireItem.childItems, pathToParent);
    if (questionnaireItem) {
      return createSelectedItem(questionnaireItem, pathToParent);
    }
    return createSelectedItem(this.data.questionnaire.questionnaireItem);
  }
  getCurrentAnswers() {
    this.answers = this.isLastSelected
      ? this.previousSelected.childItems.map((i) => i.answer)
      : this.currentSelected.childItems.map((i) => i.answer);
  }
  getCurrentQuestion() {
    this.question = this.isLastSelected
      ? this.previousSelected.question
      : this.currentSelected.question;
  }
  getPreviousSelected() {
    const { path } = this.currentSelected;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.previousSelected = this.getParentItemByPath(path);
    }
  }
  filterRanges() {
    var _a, _b;
    const rangeIds = (_a = this.currentSelected) === null || _a === void 0 ? void 0 : _a.rangeIds;
    const filteredRanges = (_b = this.data.ranges) === null || _b === void 0 ? void 0 : _b.filter((range) => {
      return rangeIds === null || rangeIds === void 0 ? void 0 : rangeIds.includes(range.rangeId);
    });
    this.ranges = filteredRanges === null || filteredRanges === void 0 ? void 0 : filteredRanges.sort((range1, range2) => {
      const rangeId1 = range1.rangeId;
      const rangeId2 = range2.rangeId;
      return rangeIds.indexOf(rangeId1) - rangeIds.indexOf(rangeId2);
    });
  }
  setIsLastSelected() {
    this.isLastSelected = !this.currentSelected.childItems.length;
  }
  createBreadcrumbs() {
    var _a, _b, _c;
    if ((_a = this.currentSelected) === null || _a === void 0 ? void 0 : _a.path) {
      let newPath;
      this.breadcrumbs = (_c = (_b = this.currentSelected) === null || _b === void 0 ? void 0 : _b.path) === null || _c === void 0 ? void 0 : _c.map((selected) => {
        newPath = newPath ? [...newPath, selected] : [selected];
        return {
          name: selected,
          path: newPath,
        };
      });
    }
    else {
      this.breadcrumbs = [];
    }
  }
  componentWillLoad() {
    const { questionnaireItem } = this.data.questionnaire;
    this.currentSelected = createSelectedItem(questionnaireItem);
  }
  render() {
    var _a, _b;
    const isFirstQuestion = !this.currentSelected.path;
    return (h("div", { class: "widget-body" }, this.isMobile ? (h("pes-widget-back-button", { backLabel: (_a = this.data.labels) === null || _a === void 0 ? void 0 : _a.backLabel, class: classnames('widget-body__back-button', {
        'widget-body__back-button--visible': this.currentSelected.path,
      }) })) : (h("pes-widget-breadcrumbs", { breadcrumbs: this.breadcrumbs, isLastSelected: this.isLastSelected })), h("div", { class: classnames('widget-body__question', {
        'widget-body__question--first': isFirstQuestion,
      }) }, h("pes-widget-header", { isLarge: isFirstQuestion }, this.question), h("pes-widget-answers", { answers: this.answers, selectedAnswer: this.currentSelected.answer })), ((_b = this.ranges) === null || _b === void 0 ? void 0 : _b.length) !== 0 && (h("pes-widget-ranges", { ranges: this.ranges, rangeTooltipInfo: this.rangeTooltipInfo, isMobile: this.isMobile, isPBS: this.isPBS, isLastSelected: this.isLastSelected, labels: this.data.labels, selectorConfig: this.selectorConfig }))));
  }
  static get watchers() { return {
    "currentSelected": ["onSelectedChange"],
    "ranges": ["onRangesDisplay"]
  }; }
};
WidgetBody.style = widgetBodyCss;

const widgetBreadcrumbsCss = ".widget-breadcrumbs{margin:0;padding:0;list-style:none;box-sizing:border-box;display:flex;flex-wrap:wrap;font-weight:400}.widget-breadcrumbs *,.widget-breadcrumbs *::before,.widget-breadcrumbs *::after{box-sizing:inherit}.widget-breadcrumbs__item{line-height:1;display:flex;align-items:center}.widget-breadcrumbs__button{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;display:inline-block;font-size:14px;line-height:18px;color:#333333;text-decoration:none}.widget-breadcrumbs__button--last{color:#9fa0a4}.widget-breadcrumbs__icon{margin:0}:host([dir=\"rtl\"]) .widget-breadcrumbs__icon{transform:scaleX(-1)}";

const WidgetBreadcrumbs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didBreadcrumbClick = createEvent(this, "didBreadcrumbClick", 7);
    this.handleBreadcrumbClick = (value) => () => {
      this.didBreadcrumbClick.emit(value);
    };
    this.breadcrumbs = [];
    this.isLastSelected = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("ul", { class: "widget-breadcrumbs" }, this.breadcrumbs.map((item, index) => {
      const lastIndex = this.breadcrumbs.length - 1;
      const isLast = this.isLastSelected && index === lastIndex;
      return (h("li", { class: "widget-breadcrumbs__item", key: item.name }, h("button", { class: classnames('widget-breadcrumbs__button', {
          'widget-breadcrumbs__button--last': isLast,
        }), onClick: this.handleBreadcrumbClick(item) }, h("span", { innerHTML: item.name })), !isLast && h("pes-icon", { class: "widget-breadcrumbs__icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
    })));
  }
  get el() { return getElement(this); }
};
WidgetBreadcrumbs.style = widgetBreadcrumbsCss;

const widgetHeaderCss = ".widget-header{font-size:18px;color:#333333;font-weight:bold;margin:20px 0 12px;text-align:center}@media screen and (min-width: 980px){.widget-header{line-height:30px;font-size:22px}}@media screen and (min-width: 980px){.widget-header--large{line-height:40px;font-size:30px;font-weight:normal;margin-top:0}}";

const WidgetHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isLarge = false;
  }
  render() {
    return (h("h1", { class: classnames('widget-header', {
        'widget-header--large': this.isLarge,
      }) }, h("slot", null)));
  }
};
WidgetHeader.style = widgetHeaderCss;

const widgetRangesCss = "@media screen and (min-width: 980px){:host{flex:1;overflow:auto;scrollbar-width:thin !important}:host::-webkit-scrollbar{width:6px;height:6px}:host::-webkit-scrollbar-thumb{background:#cbcbcb;border-radius:3px}:host::-webkit-scrollbar-track{background:#ffffff;border-radius:3px}:host{scrollbar-face-color:#cbcbcb;scrollbar-track-color:#ffffff}}@media screen and (max-width: 979px){.widget-ranges{position:absolute;height:100%;width:100%;top:0;bottom:0;left:0;right:0;background-color:#ffffff}}.widget-ranges__results{margin:20px 0;font-size:14px;color:#333333;line-height:20px}.widget-ranges__results-total{font-weight:bold}.widget-ranges__button-wrapper{position:fixed;bottom:0;left:0;right:0;margin:0 8px 20px}.widget-ranges__button-wrapper::before{content:\"\";position:absolute;height:48px;width:100%;display:block;bottom:68px}:host(:not([dir=\"rtl\"])) .widget-ranges__button-wrapper::before{background:linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%)}:host([dir=\"rtl\"]) .widget-ranges__button-wrapper::before{background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%)}.widget-ranges__button{width:100%}.widget-ranges__cards{display:flex;flex-wrap:wrap;width:100%}.widget-ranges__card{width:100%}@media screen and (min-width: 980px){.widget-ranges__card{width:50%}}.widget-ranges__shadow{position:absolute;height:48px;width:100%;bottom:0}:host(:not([dir=\"rtl\"])) .widget-ranges__shadow{background:linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%);right:6px}:host([dir=\"rtl\"]) .widget-ranges__shadow{background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%);left:6px}";

const RANGES_COUNT_PER_ROW = 2;
const NUMBER_OF_RANGES_PLACEHOLDER = '#number of ranges#';
const WidgetRanges = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onButtonClick = () => {
      this.isResultShown = true;
    };
    this.ranges = undefined;
    this.rangeTooltipInfo = undefined;
    this.selectorConfig = undefined;
    this.isMobile = undefined;
    this.isLastSelected = undefined;
    this.labels = undefined;
    this.isPBS = false;
    this.isResultShown = false;
  }
  onBackButtonClick() {
    this.isResultShown = false;
  }
  render() {
    var _a, _b, _c, _d, _e;
    const rangesTotalCount = this.ranges.length;
    if (this.isMobile && !this.isResultShown && !this.isLastSelected) {
      return (h("div", { class: "widget-ranges__button-wrapper" }, h("qds-button", { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.EMPHASIZED, class: "widget-ranges__button", block: true, onClick: this.onButtonClick, text: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcMessageWeFoundResults.replace(NUMBER_OF_RANGES_PLACEHOLDER, String(rangesTotalCount)) })));
    }
    const { hmcViewProducts, useProductSelector, featuresLabel, bestMatchLabel, hmcViewDetails, } = this.labels || {};
    const cardLabels = {
      hmcViewProducts,
      hmcViewDetails,
      useProductSelector,
      featuresLabel,
      bestMatchLabel,
    };
    return (h("div", { class: "widget-ranges" }, this.isMobile ? ([
      h("pes-widget-back-button", { backLabel: (_b = this.labels) === null || _b === void 0 ? void 0 : _b.backLabel }),
      h("pes-widget-header", null, (_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcMessageWeFoundResults.replace(NUMBER_OF_RANGES_PLACEHOLDER, String(rangesTotalCount))),
    ]) : (h("p", { class: "widget-ranges__results" }, (_e = (_d = this.labels) === null || _d === void 0 ? void 0 : _d.hmcMessageWeFoundResultsDesktop) === null || _e === void 0 ? void 0 :
      _e.replace(NUMBER_OF_RANGES_PLACEHOLDER, ''), h("span", { class: "widget-ranges__results-total" }, rangesTotalCount))), h("div", { class: "widget-ranges__cards" }, this.ranges.map((range, index) => (h("pes-hmc-card", { key: range.rangeId, class: "widget-ranges__card", range: range, page: "range", isPBS: this.isPBS, isBestMatch: this.isLastSelected && index === 0, rangeTooltipInfo: this.rangeTooltipInfo, labels: cardLabels, selectorConfig: this.selectorConfig })))), !this.isMobile && this.ranges.length > RANGES_COUNT_PER_ROW && (h("div", { class: "widget-ranges__shadow" }))));
  }
};
WidgetRanges.style = widgetRangesCss;

export { HmcCard as pes_hmc_card, HmcLink as pes_hmc_link, HmcModal as pes_hmc_modal, ProductSelector as pes_hmc_product_selector, HmcWidget as pes_hmc_widget, WidgetAnswers as pes_widget_answers, WidgetBackButton as pes_widget_back_button, WidgetBody as pes_widget_body, WidgetBreadcrumbs as pes_widget_breadcrumbs, WidgetHeader as pes_widget_header, WidgetRanges as pes_widget_ranges };
